/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Sign_In_TitleInputs */

const en_login_sign_in_title = /** @type {(inputs: Login_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign In`)
};

const fr_login_sign_in_title = /** @type {(inputs: Login_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se Connecter`)
};

const de_login_sign_in_title = /** @type {(inputs: Login_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

const it_login_sign_in_title = /** @type {(inputs: Login_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrazione`)
};

const ru_login_sign_in_title = /** @type {(inputs: Login_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войти`)
};

const es_login_sign_in_title = /** @type {(inputs: Login_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

const zh_cn2_login_sign_in_title = /** @type {(inputs: Login_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入`)
};

const ja_login_sign_in_title = /** @type {(inputs: Login_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインイン`)
};

const hi_login_sign_in_title = /** @type {(inputs: Login_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दाखिल करना`)
};

const pt_pt2_login_sign_in_title = /** @type {(inputs: Login_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar`)
};

/**
* | output |
* | --- |
* | "Sign In" |
*
* @param {Login_Sign_In_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_sign_in_title = /** @type {((inputs?: Login_Sign_In_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Sign_In_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_sign_in_title(inputs)
	if (locale === "de") return de_login_sign_in_title(inputs)
	if (locale === "it") return it_login_sign_in_title(inputs)
	if (locale === "ru") return ru_login_sign_in_title(inputs)
	if (locale === "es") return es_login_sign_in_title(inputs)
	if (locale === "zh-CN") return zh_cn2_login_sign_in_title(inputs)
	if (locale === "ja") return ja_login_sign_in_title(inputs)
	if (locale === "hi") return hi_login_sign_in_title(inputs)
	if (locale === "pt-PT") return pt_pt2_login_sign_in_title(inputs)
	return en_login_sign_in_title(inputs)
});